export * from './MyInvestmentsIcon'
